import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import classnames from 'classnames';

import styles from 'components/shared/Button/Button.module.scss';

interface LinkProps extends ClickableElementProps {
  /** @string - Link destination. Used as "href" or "to" depending on the rendered component */
  to?: string;
  /** @string - Link title attribute used for accessibility */
  title?: string;
  /** @boolean - If true renders an <a> tag. If false renders a react-router Link */
  external?: boolean;
  /**@boolean - If true renders button styles */
  isLinkButton?: boolean;
  onClick?: () => void;
}

export const Link: React.FC<LinkProps> = ({
  to,
  className,
  children,
  title,
  type,
  size,
  theme,
  external,
  onClick,
  isLinkButton,
}) => {
  // TODO address this better isLinkButton
  const linkClasses = classnames('controlContainer', className, styles[`size${size}`], {
    [styles.button]: isLinkButton,
    [styles[`type${type}`]]: type ? true : false,
    [styles[`theme${theme}`]]: theme ? true : false,
  });

  if (external) {
    return (
      <a
        href={to}
        className={linkClasses}
        title={title}
        target="_blank"
        rel="noreferrer noopener"
        onClick={onClick}
      >
        {children}
      </a>
    );
  } else {
    return (
      <RouterLink to={to || ''} className={linkClasses}>
        {children}
      </RouterLink>
    );
  }
};

export default Link;
